import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {
  @Input() totalResults = 0; // Total number of items
  @Input() pageSize = 10; // Items per page
  @Input() currentPage = 1; // Current active page
  @Output() pageChanged = new EventEmitter<number>();
  @Input() activeLiClass = ''; // New input for active link style
  @Input() activeLinkClass = ''; // New input 
  @Input() liClass='';
  @Input() linkClass='';
  @Input() paginatorContainerClass ='';
  @Input() rangeSize =3;

  get shouldShowPaginator(): boolean {
    return this.totalResults > this.pageSize;
  }
  
  get pageCount(): number {
    return Math.ceil(this.totalResults / this.pageSize);
  }

  get pages(): number[] {
    const pages = [];
    
    let start = Math.max(this.currentPage - this.rangeSize, 1);
    let end = Math.min(this.currentPage + this.rangeSize, this.pageCount);

    // Handling ".." for left side
    if (start > 2) {
      pages.push(1, -1);  // -1 represents the ".."
    } else {
      start = 1;
    }

    // Push the range into the array
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Handling ".." for right side
    if (end < this.pageCount - 1) {
      pages.push(-1, this.pageCount);  // -1 represents the ".."
    } else if (end < this.pageCount) {
      pages.push(this.pageCount);
    }

    return pages;
  }

  changePage(page: number): void {
    if (page !== this.currentPage && page > 0 && page <= this.pageCount) {
      this.currentPage = page;
      this.pageChanged.emit(page);
    }
  }
}
